// React Imports
import React from 'react';

// Mui Imports
import {Avatar, Tooltip} from '@mui/material';
import {GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import {deepOrange, green, grey, lightGreen} from "@mui/material/colors";

// App Imports
import WorkIssuanceStatusMenu from "../Status/WorkIssuanceStatusMenu";
import Box from "@mui/material/Box";


// main function
export const WorkIssuanceObligationGridColumns = ({ hideActions,  expandCdpId, openSourceWindow, contracts, handleMousedRow,handleClickedRow,handleExploreExternalData }) =>

    // ***************** BEGIN COLUMNS ***************************

    [
    {
        field: 'rowId',
        headerName: 'id',
        description: '',
        sortable: true,
        editable: true,
        width: 60,
        hide: true
    },
        // {
        //     field: 'contractName',
        //     headerName: 'On Contract',
        //     description: '',
        //     sortable: false,
        //     filterable: false,
        //     editable: true,
        //     // editable: true,
        //     width: 350,
        //     hide: false
        // },
        {
            field: 'contractName',
            headerName: 'On Contract',
            width: 350,
            sortable: false,
            filterable: false,
            editable: false,
            renderCell: (contractDataPoints) => (
                <span
                    style={{
                        cursor: 'pointer',
                        // color: '#1976d2',
                        // textDecoration: 'underline'
                    }}
                    onClick= {() => handleClickedRow(contractDataPoints.row)}
                >
            {contractDataPoints.value}
        </span>
            )
        },
    {
        field: 'reuseMarket',
        headerName: 'Reuse Market',
        description: '',
        sortable: false,
        editable: true,
        width: 200,

    },
    //
    {
        field: 'cdpId',
        headerName: 'cdpId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'dataPointId',
        headerName: 'dataPointId',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'obligationStatusOld',
        headerName: 'StatusOld',
        description: '',
        sortable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: "obligationStatus",
        headerClassName: 'colored-header',
        headerName: 'Status',
        disableColumnMenu: true,
        width: 80,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filterable: false,
        hide: true,
        renderCell: (fetchObligations) => {

            if (fetchObligations.row.obligationStatus === "2339" && fetchObligations.row.versionNumber > 0 ) {
                return (
                    <div onMouseOver={() => handleMousedRow(contracts.row)}>
                        <Tooltip title={"Generated"}>
                            <Avatar sx={{ml: 1.5, height: 20, width: 20, fontSize: 14, backgroundColor: '#1E90FF'}}>g
                            </Avatar>
                        </Tooltip>
                    </div>)}
            if (fetchObligations.row.obligationStatus === "2345" && fetchObligations.row.versionNumber > 0) {
                return (
                    <div onMouseOver={() => handleMousedRow(contracts.row)}>
                        <Tooltip title={"Approved"}>
                            <Avatar sx={{ml: 1.5, height: 20, width: 20, fontSize: 14, backgroundColor: '#66BB6A'}}>a
                            </Avatar>
                        </Tooltip>
                    </div>)}
            else return(
                <div></div>
            )

        }
    },

    {
        field: "more",
        headerName: '',
        width: 20,
        padding: 0,
        margin: 0,
        sortable: false,
        menu: false,
        filter: false,
        hide: true,
        renderCell: (contractDataPoints) => {
            return (
                // <MoreHorizIcon fontSize={'small'} onClick= {() => handleControls()}/>
                <WorkIssuanceStatusMenu/>

            );
        }

    },
    {
        field: 'dataPointName',
        headerName: 'Data Point',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 400,
        hide: false,
        renderCell: (contractDataPoints) => {
            return (
                <Tooltip  enterDelay={1000}  enterNextDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                    {"dp id: " + contractDataPoints.row.dataPointId +
                        "\ncdp id: " + contractDataPoints.row.cdpId +
                        "\ncdpv id: " + contractDataPoints.row.cdpvId +
                        "\nhierarchy: " + contractDataPoints.row.hierarchy +
                        "\nhierarchy order: " + contractDataPoints.row.hierarchyOrder +
                        "\nhierarchy level: " + contractDataPoints.row.hierarchyLevel
                        // "\nsource section id: " + workQueueCDP.row.sourceContractSectionId +
                        // "\nsource contract data point id: " + workQueueCDP.row.sourceContractDataPointId
                    }</span>}>
                    <div className="rowitem"
                         onClick= {() => handleClickedRow(contractDataPoints.row)}
                        // onClick= {() => handleExpression(workQueueCDP.row.id,  workQueueCDP.row.contractSectionId, fetchWorkQueueCDP)}
                         style={{cursor:'pointer',   backgroundColor: contractDataPoints.row.cdpId === expandCdpId ? 'yellow' : 'transparent'}}
                    >{contractDataPoints.row.dataPointName}</div></Tooltip>)}
    },
    {    field: 'contractId',
        headerName: 'Contract ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {    field: 'hierarchyOrder',
        headerName: 'Hierarchy Order',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {    field: 'hierarchyLevel',
        headerName: 'Hierarchy Level',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },
    {    field: 'contractId',
        headerName: 'Contract ID',
        description: '',
        sortable: true,
        width: 60,
        hide: true
    },

    {
        field: 'dataType',
        headerName: 'dataType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'sourceType',
        headerName: 'sourceType',
        description: '',
        sortable: false,
        editable: true,
        width: 100,
        hide: true
    },
    {
        field: 'dataPointRange',
        headerName: 'Range',
        description: '',
        sortable: false,
        editable: true,
        width: 80,
        hide: true
    },
    {
        field: 'cdpId',
        headerName: 'CDP ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'cdpvId',
        headerName: 'CDPV ID',
        description: '',
        sortable: false,
        editable: true,
        width: 60,
        hide: true
    },
    {
        field: 'iterationNumber',
        headerName: '#',
        description: '',
        sortable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 15,
        hide: false
    },
    {
        field: 'value',
        headerName: 'raw value',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 110,
        hide: true
    },
    {
        field: 'displayValue',
        headerName: 'Value',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        align: 'right', // aligns cell content
        headerAlign: 'right', // optional: aligns header text too
        width: 150,
        hide: false
    },
    {
        // field: 'mockIndicator',
        field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
        type: 'actions',  // Required for built-in expand behavior
        headerName: 'Expression',
        renderCell: (contracts) =>
        {
            if((contracts.row.expression !== null) && (contracts.row.expression !== '')){
                return (
                    <Tooltip title={"Value comes from an expression.  Click to see."}>
                        <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                    </Tooltip>)}
            // if(contracts.row.mockIndicator=='m'){
            //     return (
            //         <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{contracts.row.mockIndicator} </Avatar>)}
        },
        description: '',
        sortable: false,
        width: 90,
    },
    // {
    //     field: 'externalData',
    //     headerName: 'External Data',
    //     description: '',
    //     sortable: false,
    //     width: 100,
    //     renderCell: (contracts) =>
    //     {
    //
    //         if((contracts.row.externalData !== null) && ( contracts.row.hierarchyLevel > 1)) {
    //             // if(filteredCDP.row.mockIndicator==='f'){
    //             return (
    //                 <Tooltip   enterDelay={1000}  title={"Data comes from external source.  Click to see details."}>
    //                     {/*<AccountTreeIcon*/}
    //                     {/*    onClick= {() => handleExploreExternalData( contracts.row)}*/}
    //                     {/*/>)}*/}
    //                     <Avatar
    //                         onClick= {() => handleExploreExternalData( contracts.row)}
    //                         sx={{ height:20, width: 20, fontSize: 16, bgcolor: lightGreen[500] }}>d</Avatar>
    //                     {/*sx={{ height:20, width: 20, fontSize: 16, bgcolor: teal[500] }}>{filteredCDP.row.mockIndicator} </Avatar>*/}
    //                 </Tooltip>)}
    //
    //     },
    // },
        {
            field: 'externalData',
            headerName: 'External Data',
            description: '',
            sortable: false,
            width: 100,
            renderCell: (contracts) => {
                if((contracts.row.externalData !== null) && ( contracts.row.hierarchyLevel > 1)) {
                    return (
                        <Box sx={{ position: 'relative', display: 'inline-flex' }}>
                            <Tooltip
                                enterDelay={1000}
                                enterNextDelay={1000}
                                title={"Data comes from external source. Click to see details."}
                            >
                                <Avatar
                                    onClick={() => handleExploreExternalData(contracts.row)}
                                    sx={{
                                        height: 20,
                                        width: 20,
                                        fontSize: 16,
                                        bgcolor: lightGreen[500],
                                        cursor: 'pointer'
                                    }}
                                >
                                    d
                                </Avatar>
                            </Tooltip>

                            {contracts.row.adjustedInd === true && (
                                <Tooltip
                                    enterDelay={1000}
                                    enterNextDelay={1000}
                                    title={"Adjustment(s)"}
                                >
                                    <Box
                                        sx={{
                                            position: 'absolute',
                                            top: -3,
                                            right: -8,
                                            height: 12,
                                            width: 12,
                                            minWidth: 12,
                                            borderRadius: '50%',
                                            backgroundColor: 'black',
                                            color: 'white',
                                            fontSize: 12,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            lineHeight: 1,
                                            cursor: 'pointer'
                                        }}
                                        onClick={(e) => e.stopPropagation()}
                                    >
                                        a
                                    </Box>
                                </Tooltip>
                            )}
                        </Box>
                    );
                }
                return null;
            },
        },
    {
        field: 'sourceContractDataPointId',
        headerName: 'Source',
        description: '',
        renderCell: ({ row }) => {
            if (!row.sourceSection) return <div />;

            // Collect non-null parent sections from 10 down to 1
            const parentSections = [];
            for (let i = 10; i >= 1; i--) {
                const section = row[`sourceParentSection${i}`];
                if (section) parentSections.push(section);
            }

            const tooltipText = `from:\n${row.sourceContractName}\n\nin:\n${parentSections.join('\n')}\n${row.sourceSection}`;

            return (
                <Tooltip placement="right-end" title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipText}</span>}>
                    <Avatar
                        sx={{ height: 20, width: 20, fontSize: 16, bgcolor: grey[500] }}
                        onClick={() => openSourceWindow(row)}
                    >
                        s
                    </Avatar>
                </Tooltip>
            );
        }
    }
    ,

    {
        field: 'hierarchyLevel',
        headerName: 'hierarchyLevel',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchyOrder',
        headerName: 'hierarchyOrder',
        description: '',
        sortable: false,
        editable: true,
        width: 20,
        hide: true
    },
    {
        field: 'hierarchy',
        headerName: 'Hierarchy',
        description: '',
        sortable: false,
        filterable: false,
        editable: true,
        width: 80,
        hide: true
    },

];

// *************** END COLUMNS *******************************
